export const load = () => ({
	title: 'Local Energy Rebates & Window Insulation Savings',
	h1: 'Saving on Energy Efficiency After the Federal Tax Credit',
	description:
		"Federal tax credits have changed, but state and local incentives remain. Learn how to maximize your ROI with Indow's pricing and energy savings.",
	showTitle: true,
});
